import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';

function CreatePrivateScreen() {
    const navigate = useNavigate();
    const [formFields, setFormFields] = useState({language_id: '', level_id: '', tutor_id: '', avail_days: '', sub_amount: ''});
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const {setUserProfile, userProfile, logOutFunction, reloadUser} = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const submit = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("language_id", formFields.language_id);
        formData.append("level_id", formFields.level_id);
        formData.append("tutor_id", formFields.tutor_id);
        formData.append("avail_days", formFields.avail_days);
        formData.append("sub_amount", formFields.sub_amount);

        try {
            const response = await axios.post(base_url + '/classes/create-private-class.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoading(false);
                setTostMessage({
                    messageType: "success",
                    message: response.data.response,
                });
                setFormFields({language_id: '', level_id: '', tutor_id: '', avail_days: '', sub_amount: ''});
                window.history.back()
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='flex flex-row justify-between'>
                    <div className="w-full px-10 py-[4rem] bg-[#FAFAFA] rounded-lg">
                        <h1 className="text-2xl font-bold text-gray-800 mb-6">Add Private Class</h1>
                        <div className="flex inline-flex flex-wrap w-full justify-between">
                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Select Language <span className="text-red-500">*</span>
                                </label>
                                <select onChange={(e) => setFormFields({...formFields, language_id: e.target.value})} className="border border-gray-300 h-[61px] px-3 py-2 rounded-md text-sm text-gray-700 w-full focus:outline-none focus:ring-2 focus:ring-yellow">
                                    <option value="">Select option</option>
                                    {location?.state?.params?.languages?.map((item, index) => 
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )}
                                </select>
                            </div>
                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Select Class Level <span className="text-red-500">*</span>
                                </label>
                                <select onChange={(e) => setFormFields({...formFields, level_id: e.target.value})} className="border border-gray-300 h-[61px] px-3 py-2 rounded-md text-sm text-gray-700 w-full focus:outline-none focus:ring-2 focus:ring-yellow">
                                    <option value="">Select option</option>
                                    {location?.state?.params?.levels?.map((item, index) => 
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )}
                                </select>
                            </div>

                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Select Tutor <span className="text-red-500">*</span>
                                </label>
                                <select onChange={(e) => setFormFields({...formFields, tutor_id: e.target.value})} className="border border-gray-300 h-[61px] px-3 py-2 rounded-md text-sm text-gray-700 w-full focus:outline-none focus:ring-2 focus:ring-yellow">
                                    <option value="">Select option</option>
                                    {location?.state?.params?.tutors?.map((item, index) => 
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )}
                                </select>
                            </div>

                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Available Day(s) <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="E.g (Mon, Tue, Thur)"
                                    onChange={(e) => setFormFields({...formFields, avail_days: e.target.value})}
                                />
                            </div>

                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Amount Per Class <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter Amount (USD)"
                                    onChange={(e) => setFormFields({...formFields, sub_amount: e.target.value})}
                                />
                            </div>
                            
                            <div className='w-full mt-3 flex justify-end'>
                                <ButtonSmall onPress={() => submit()} label={'Save'} loading={loading} />
                            </div>
                        </div>
                        </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default CreatePrivateScreen;
